import { QueryKey } from '@tanstack/react-query';
import { useAppQuery } from '../../../../../services/appQuery';
import { fetchBillingSearchServices, BillingService } from './serviceSearchHelper';

export type BillingSearchResponse = BillingService[];

interface UseBillingSearchServicesProps {
  search: string;
  category?: string;
  patientId?: string | number;
  tariffId?: string | number;
  enabled?: boolean;
  debounceMs?: number;
}

export function useBillingSearchServices({
  search,
  category = '',
  patientId,
  tariffId,
  enabled = true,
  debounceMs = 300,
}: UseBillingSearchServicesProps) {
  const key: QueryKey = ['billing', 'services', { category, search, patientId, tariffId }];

  const queryFn = () => fetchBillingSearchServices(category, search, patientId, tariffId || undefined);

  return useAppQuery<BillingSearchResponse>(key, queryFn, {
    enabled: enabled && !!search.trim(),
    debounceMs,
  });
}
